import React from 'react';
import './ServicesPage.css';

const ServicesPage: React.FC = () => {
  const services = [
    {
      id: 1,
      title: "Architectural Design",
      subtitle: "Beautiful Spaces That Work",
      description: "We design stunning buildings that look amazing and work perfectly for your needs. From your first idea to the final blueprints, we create spaces that are both beautiful and practical, making sure everything meets building codes and your vision comes to life.",
      features: ["Initial Concept & Ideas", "3D Models & Visualization", "Detailed Building Plans", "Building Permits Help", "Site Planning"]
    },
    {
      id: 2,
      title: "Interior Design",
      subtitle: "Spaces That Feel Like You",
      description: "Turn your rooms into spaces that truly reflect who you are and how you live. We help you choose the right colors, materials, lighting, and furniture to create comfortable, beautiful interiors that you'll love coming home to every day.",
      features: ["Room Layout Planning", "Materials & Finishes", "Lighting Design", "Color Schemes", "Furniture Placement", "Decorative Touches"]
    },
    {
      id: 3,
      title: "Design & Build",
      subtitle: "We Handle Everything",
      description: "From design to move-in day, we take care of your entire project. We manage the construction, build custom furniture, and watch over every detail on-site to make sure everything is done right and on time.",
      features: ["Construction Management", "Custom Furniture Making", "On-Site Supervision", "Quality Checking", "Time & Budget Control"]
    },
    {
      id: 4,
      title: "Custom Furniture",
      subtitle: "Made Just for You",
      description: "Get furniture pieces made specifically for your space and style. Our skilled craftsmen create unique, high-quality pieces that fit perfectly in your home and last for years, designed exactly how you want them.",
      features: ["Custom Design Process", "Quality Materials", "Skilled Craftsmanship", "Precise Building", "Professional Setup", "Quality Promise"]
    },
    {
      id: 5,
      title: "Post-Project Services",
      subtitle: "We're Here for the Long Run",
      description: "Our partnership continues after your project is done. We help you maintain your beautiful space with ongoing support, warranty coverage, and advice for future improvements to keep everything looking and working perfectly.",
      features: ["Future Planning Help", "Repair Services", "Ongoing Partnership"]
    }
  ];

  return (
    <main>
      <section className="services-wrapper">
        <div className="container">
          <div className="services-heading">
            <h1>Our <span id="gold">Services</span></h1>
            <p>We offer comprehensive architectural and design services to bring your vision to life.</p>
          </div>

          <div className="services-content">
            {services.map((service, index) => (
              <div key={service.id} className={`service-section ${index % 2 === 1 ? 'reverse' : ''}`}>
                <div className="service-number-display">
                  <span className="large-number">{service.id}</span>
                </div>

                <div className="service-content">
                  <div className="service-header">
                    <h2 className="service-title">{service.title}</h2>
                    <h3 className="service-subtitle">{service.subtitle}</h3>
                  </div>

                  <p className="service-description">{service.description}</p>

                  <div className="service-features">
                    <h4 className="features-title">Key <span id="gold">Capabilities</span></h4>
                    <div className="features-grid">
                      {service.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="feature-item">
                          <span className="feature-bullet">•</span>
                          <span className="feature-text">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="services-cta">
            <h2>Ready to Start Your Project?</h2>
            <p>Contact us today to discuss how we can help bring your architectural vision to life.</p>
            <a href="/contact" className="primary-cta">
              <div className="btn-text">
                <h4>Get In Touch</h4>
              </div>
              <div className="btn-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14m-7-7 7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;